module.exports = __webpack_public_path__ + "static/img/small_curry.0a8cab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/small_curry.png
// module id = Y2te
// module chunks = 34